import { useEffect } from 'react';
import { LayoutGrid } from 'lucide-react';
import { installActivityListeners, useVault } from './lib/vault';
import { LoginScreen } from './components/LoginScreen';
import { IdentityGate } from './components/IdentityGate';
import { Workspace } from '../apps/vault/components/Workspace';
// Runs the vault module's side-effect — registers its lock callback so
// decrypted attachment blobs are scrubbed when the user locks.
import '../apps/vault';

export function App() {
  const status = useVault((s) => s.status);

  useEffect(() => {
    const saved = localStorage.getItem('dragonhq.autoLockMs');
    if (saved) useVault.getState().setAutoLockMs(Number(saved));
    useVault.getState().hydrate();
    return installActivityListeners();
  }, []);

  if (status === 'hydrating') {
    return (
      <div className="min-h-screen flex items-center justify-center text-ink-500">
        <LayoutGrid className="text-dragon-500 animate-pulse mr-2" size={20} />
        <span>Restoring session…</span>
      </div>
    );
  }
  if (status === 'signed_out') return <LoginScreen />;

  // Session is authenticated. Boot straight into the Documentation
  // workspace wrapped in the identity gate (which presents Master Code
  // setup / invitation-pending / unlock screens as needed).
  return (
    <IdentityGate>
      <Workspace />
    </IdentityGate>
  );
}
